export class UrlConstants {
  static readonly loginUrl = '/auth/login';
  static readonly customRedirectUrl = '/redirect';
  static readonly appBaseUrl = '/app';
  static readonly eulaUrl = '/eula';
  static readonly loginRedirectUrl = '/eula';
  static readonly authCallback = '/auth/cb';
  static readonly authWellknownEndpointUrl = '/.well-known/openid-configuration';
  static readonly adminPageUrl = '/app/eligibility/admin';
  static readonly payerCredManagementUrl = '/app/eligibility/admin/payer-credentials';
  static readonly dailyHuddletUrl = '/app/eligibility/daily-huddle';
  static readonly embedSessionInvalidUrl = '/e/invalid';
}
